// build-shims.js — injected by esbuild to map CDN globals
export const React = window.React;
export const ReactDOM = window.ReactDOM;
export const THREE = window.THREE;
